// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2y-3";
export var dialog = "_2y-0";
export var divClassnameSwatch = "_2y-8";
export var flexSwatch = "_2y-4";
export var header = "_2y-1";
export var styleAttributeSwatch = "_2y-7";
export var swatch = "_2y-2";
export var textHeaderSwatch = "_2y-5";
export var webSwatch = "_2y-6";